import React, {Component} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';
import {SMALL, MEDIUM} from '../../../helpers/IconSize';
import {buildMessage} from '../../../helpers/helpers';

import './BaseUnitMessage.less';

export default class BaseUnitMessage extends Component {
    static defaultProps = {
        className: '',
        size: MEDIUM,
        unitMessage: {},
        color: false,
        ariaHidden: false
    };
    static contextType = TrackingContext;

    static getUnitMessageContent(unitMessage) {
        if (unitMessage) {
            const {iconTextV1, iconTextV2, iconText, secondaryIconText} = unitMessage;
            return iconTextV1 || iconTextV2 || iconText || secondaryIconText || {};
        }
        return {};
    }

    BASE_CLASS = 'UrgencyUnitMessage';

    generateComponent = ({className, style, src, icon, message, link, size, ariaHidden}) => {

        return (
            <div className={`${this.BASE_CLASS} ${className}`} aria-hidden={ariaHidden}>
                {
                    src &&
                    <div className={`${this.BASE_CLASS}__img--${size}`}>
                        <img style={style} src={src} alt={icon} />
                    </div>
                }
                <span className={`${this.BASE_CLASS}__text${size === SMALL ? '--s' : ''}`}>
                    {buildMessage(message, link, `${this.BASE_CLASS}__link`)}
                </span>
            </div>
        );
    };
}
